const icon = require('vue-svgicon');
icon.register({
    'quote': {
        width: 36,
        height: 32,
        viewBox: '0 0 36 32',
        data: `<path d="M14.5862 3.15271C9.15517 8.19704 6.51724 12.9261 5.74138 17.9704C6.2069 17.8128 6.67241 17.8128 7.13793 17.8128C11.1724 17.8128 14.2759 20.6502 14.2759 24.9064C14.2759 29.7931 10.7069 32 7.13793 32C4.18965 32 0 29.7931 0 22.5419C0 13.8719 5.27586 5.51724 11.6379 0L14.5862 3.15271ZM28.5517 17.8128C32.5862 17.8128 35.6897 20.6502 35.6897 24.9064C35.6897 29.7931 32.1207 32 28.5517 32C25.4483 32 21.4138 29.7931 21.4138 22.5419C21.4138 13.8719 26.6897 5.51724 33.0517 0L36 3.15271C30.569 8.19704 27.931 12.9261 27.1552 17.9704C27.6207 17.8128 28.0862 17.8128 28.5517 17.8128Z" _fill="#000" />`,
    },
});
